/* eslint-disable react/jsx-handler-names */
import { DesignObligation, MaturityStage, ProductBuildingBlock } from '@/gql/graphql';
import { GroupedBuildingBlock, SortedBuildingBlock } from '@/hooks/use-building-blocks/use-building-blocks.hook.core';
import { BuildingBlockList } from './building-blocks-list.component/building-blocks-list.component';

type Props = {
  sort: 'DO' | 'MTS';
  enableInclusion?: boolean;
  selectedBuildingBlockId?: string;
  onBBInclusionChange?: (groupedBB: GroupedBuildingBlock<DesignObligation>, including: boolean) => void;
  onBlockClick?: (bb: ProductBuildingBlock) => void;
  includedBuildingBlocks: SortedBuildingBlock<DesignObligation | MaturityStage>;
  excludedBuildingBlocks: SortedBuildingBlock<DesignObligation | MaturityStage>;
  selectedTab: 'included' | 'excluded';
  // being passed from the tailoring layout directly
  height?: number;
};

export const BuildingBlocks = ({
  sort,
  enableInclusion,
  selectedBuildingBlockId,
  onBBInclusionChange,
  onBlockClick: handleBlockClick,
  includedBuildingBlocks,
  excludedBuildingBlocks,
  selectedTab,
  height,
}: Props) => {
  return (
    <div className="flex flex-col gap-4 h-full">
      {selectedTab === 'included' && (
        <BuildingBlockList
          sort={sort}
          height={height}
          context="included"
          buildingBlocks={includedBuildingBlocks}
          enableInclusion={enableInclusion}
          selectedBuildingBlockId={selectedBuildingBlockId}
          handleBlockClick={handleBlockClick}
          onBBInclusionChange={onBBInclusionChange}
        />
      )}
      {selectedTab === 'excluded' && (
        <BuildingBlockList
          sort={sort}
          height={height}
          context="excluded"
          buildingBlocks={excludedBuildingBlocks}
          enableInclusion={enableInclusion}
          selectedBuildingBlockId={selectedBuildingBlockId}
          handleBlockClick={handleBlockClick}
          onBBInclusionChange={onBBInclusionChange}
        />
      )}
    </div>
  );
};
